module.exports = __webpack_public_path__ + "img/expiredPlan.8ea6ea64.png";